// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.DateTimeUnit
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DateTimeUnit = /*#__PURE__*/function (DateTimeUnit) {
  DateTimeUnit[DateTimeUnit["None"] = 0] = "None";
  DateTimeUnit[DateTimeUnit["Second"] = 1] = "Second";
  DateTimeUnit[DateTimeUnit["Minute"] = 2] = "Minute";
  DateTimeUnit[DateTimeUnit["Hour"] = 3] = "Hour";
  DateTimeUnit[DateTimeUnit["Day"] = 4] = "Day";
  DateTimeUnit[DateTimeUnit["Week"] = 5] = "Week";
  DateTimeUnit[DateTimeUnit["Month"] = 6] = "Month";
  DateTimeUnit[DateTimeUnit["Year"] = 7] = "Year";
  return DateTimeUnit;
}({});
(function (_DateTimeUnit) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DateTimeUnit[enumVal] != null ? enumVal : undefined : DateTimeUnit[enumVal];
  }
  _DateTimeUnit.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DateTimeUnit.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DateTimeUnit.indexOf = indexOf;
})(DateTimeUnit || (DateTimeUnit = {}));
//# sourceMappingURL=DateTimeUnit.js.map
